import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { SchedulingTimezoneMessage } from "./SchedulingTimezoneMessage";

export function SchedulingTimezoneMessageContainer() {
  const userTimezoneOption = useUserTimezoneOption();

  return (
    <SchedulingTimezoneMessage timezoneLabel={userTimezoneOption?.label} />
  );
}

export default SchedulingTimezoneMessageContainer;
